import { type Message } from "shared/apiClient";
import { type Noticeboard } from "shared/lib";

import {
  getReportLoadingProgressIndicatorItems,
  type ProgressIndicatorItemMap,
} from "@/lib/reportLoader";

import { ApplicationRequirementsLoader } from "./ApplicationRequirementsLoader";

export interface ApplicationRequirementsLoaderContainerProps {
  latestUserMessage?: Message;
  noticeboardData: Noticeboard | undefined | null;
  progressIndicatorItemMap: ProgressIndicatorItemMap;
  title: string;
}

export function ApplicationRequirementsLoaderContainer({
  latestUserMessage,
  noticeboardData,
  progressIndicatorItemMap,
  title,
}: ApplicationRequirementsLoaderContainerProps) {
  return (
    <ApplicationRequirementsLoader
      items={getReportLoadingProgressIndicatorItems(
        noticeboardData || {},
        parseInt(latestUserMessage?.message_number || "-999"),
        progressIndicatorItemMap,
      )}
      title={title}
    />
  );
}
